import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from 'i18n/locales/en.json'
import fr from 'i18n/locales/fr.json'

const resources = {
  en: {
    translation: en
  },
  fr: {
    translation: fr
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false, // Disable suspense for SSR compatibility
    }
  })

function applyDocumentLanguage(language?: string) {
  if (typeof document === 'undefined') return
  const base = (language || i18n.language || 'en').split('-')[0]
  document.documentElement.lang = base === 'fr' ? 'fr' : 'en'
}

i18n.on('languageChanged', applyDocumentLanguage)
i18n.on('initialized', () => applyDocumentLanguage(i18n.language))

export default i18n
